module.exports = __webpack_public_path__ + "img/img_duihuan_duihuan.08608860.png";